import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.DealerGroupClaimType.Delete.IRequest;
type Response = Api.Core.DealerGroupClaimType.Delete.IResponse;
type Headers = Api.Core.DealerGroupClaimType.Delete.IHeaders;
const saveApiDealerGroupClaimTypePath = '/api/DealerManagement/DealerGroupClaimType/:id';
export default async function dealerGroupClaimTypeDeleteApi(params: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    url: createPathFromRoute(saveApiDealerGroupClaimTypePath, params, null),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
